import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import type { SiteModeConfig } from '../../lib/siteMode';

type MaintenanceScreenProps = {
  config: SiteModeConfig;
  loginHref?: string;
  showStaffAccess?: boolean;
};

export default function MaintenanceScreen({
  config,
  loginHref = '/login',
  showStaffAccess = true,
}: MaintenanceScreenProps) {
  return (
    <div className="min-h-screen bg-[#1c2937] text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(45,212,191,0.16),transparent_38%),radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.08),transparent_30%)]" />
      <div className="relative min-h-screen px-6 py-8 flex flex-col">
        <div className="flex items-center justify-center md:justify-start">
          <BrandLogo variant="white" size="lg" />
        </div>

        <div className="flex-1 flex items-center justify-center">
          <div className="max-w-3xl text-center">
            <span className="inline-flex px-4 py-1.5 rounded-full border border-teal-400/30 bg-teal-400/10 text-teal-300 text-xs font-semibold tracking-[0.32em] uppercase">
              {config.eyebrow}
            </span>
            <h1
              className="mt-6 text-4xl md:text-6xl font-bold leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {config.title}
            </h1>
            <p className="mt-6 text-lg md:text-2xl leading-relaxed text-slate-200">
              {config.description}
            </p>
            <p className="mt-5 text-sm md:text-base text-slate-400">
              {config.note}
            </p>
            {showStaffAccess && (
              <div className="mt-8">
                <Link
                  to={loginHref}
                  className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-5 py-3 text-sm font-semibold text-white hover:bg-white/10 transition-colors"
                >
                  <i className="ri-shield-user-line" />
                  Staff Login
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
